import { STATS, HIGHLIGHT_STAT, COPY } from "@/lib/site";
import { Reveal } from "./Motion";

export const Performance = () => {
  return (
    <section
      id="performance"
      data-testid="performance-section"
      className="bg-ink text-beige py-24 md:py-36"
    >
      <div className="container-editorial">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 md:mb-24">
          <div>
            <p className="kicker !text-beige/60 mb-5">{COPY.performance.kicker}</p>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
              {COPY.performance.headingLine1}
              <br />
              <span className="italic text-beige/70">{COPY.performance.headingLine2}</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm md:text-base font-light text-beige/70 leading-relaxed">
            {COPY.performance.intro}
          </p>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8 border-t border-beige/15 pt-14">
          {STATS.map((s, i) => (
            <Reveal
              key={s.label}
              delay={i * 0.06}
              className="border-l border-beige/15 pl-5"
            >
              <div className="font-display text-5xl md:text-6xl lg:text-7xl leading-none tracking-tight">
                {s.value}
              </div>
              <div className="mt-4 text-[13px] font-medium uppercase tracking-[0.16em]">
                {s.label}
              </div>
              <div className="mt-1 text-xs text-beige/50">{s.note}</div>
            </Reveal>
          ))}

          {/* Highlighted 88% block */}
          <Reveal
            delay={0.1}
            data-testid="highlight-stat"
            className="col-span-2 lg:col-span-4 mt-2"
          >
            <div className="bg-beige text-ink rounded-sm p-8 md:p-12 flex flex-col md:flex-row md:items-center gap-8 md:gap-14">
              <div className="font-display text-[6rem] md:text-[10rem] leading-[0.8] tracking-tighter">
                {HIGHLIGHT_STAT.value}
              </div>
              <div className="md:border-l md:border-ink/20 md:pl-14">
                <div className="text-sm font-semibold uppercase tracking-[0.18em]">
                  {HIGHLIGHT_STAT.label}
                </div>
                <p className="mt-4 max-w-md text-base md:text-lg font-light leading-relaxed text-ink/75">
                  {COPY.performance.highlightBody}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
